const REQUEST_OK = 'requestStatus/OK';
const REQUEST_ERR = 'requestStatus/ERR';
const REQUEST_WAIT = 'requestStatus/WAIT';

export type RequestStatus = typeof REQUEST_OK | typeof REQUEST_ERR | typeof REQUEST_WAIT;

export const RequestStatus = {
  OK: REQUEST_OK as typeof REQUEST_OK,
  ERR: REQUEST_ERR as typeof REQUEST_ERR,
  WAIT: REQUEST_WAIT as typeof REQUEST_WAIT,
};
